<div class="container">
  <mat-toolbar class="custom-header">
  <span (click)="closeModal()">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
  <h2>{{"PROFILE.NUTRITION.BEFORE-START" | translate}}</h2>
  <div *ngIf="translate.currentLang ==='it'">
    <h3>Per semplificare il tuo approccio alla dieta, ecco una serie di chiarimenti e spiegazioni:</h3>
    <ul>
      <li>Ricorda che una dieta sana e valida deve includere tutti gli alimenti e che "proteico" non significa
        necessariamente "dimagrante".</li>
      <li>Evita il fumo, sia attivo che passivo.</li>
      <li>Consuma quotidianamente ortaggi e frutta fresca. Aumenta il consumo di legumi, sia freschi che secchi.</li>
      <li>Grassi: Preferisci i grassi da condimento di origine vegetale, soprattutto l'olio
        extravergine d'oliva, ricco in polifenoli.</li>
      <li>Usa i condimenti a crudo e non utilizzare oli e grassi già cotti.</li>
      <li>Leggi consapevolmente le etichette.</li>
      <li>Limita i prodotti contenenti saccarosio, specialmente quelli che si attaccano ai denti.</li>
      <li>Se desideri consumare alimenti o bevande dolci ipocalorici con edulcoranti, leggi sull'etichetta il tipo di
        edulcorante utilizzato e le avvertenze da seguire.</li>
      <li>Evita le salse pronte, le verdure fritte o pastellate, gli insaccati, la salsiccia e le salse da insalata.
      </li>
      <li>Tutte le grammature sono riferite a crudo e al netto degli scarti.</li>
      <li>Pranzo e cena sono perfettamente interscambiabili.</li>
      <li>Evita gli insaporitori già confezionati, poiché ricchi in sale.</li>
      <li>Pesce: puoi consumare anche molluschi (cozze, vongole, ostriche) e cefalopodi (polpo,
        calamari, seppie, ecc.).</li>
      <li>Si considera fresco anche il pesce surgelato. Quando consumi il salmone (sia fresco che affumicato), limita
        l'uso di olio nel pasto.</li>
      <li>La frutta, quando viene consumata come spuntino, sarebbe ideale associarla a una buona fonte di grassi
        "buoni", come ad esempio l’avocado, il cioccolato fondente o la frutta secca.</li>
      <li>Una volta a settimana, consiglio un piatto unico a base di legumi costituito da:
        <ul>
          <li>50 g di cereale (pane, pasta, riso, farro, orzo, ecc.),</li>
          <li>50 g di legumi (se secchi, oppure 150 g se in scatola),</li>
          <li>circa 200 g di verdura/ortaggi.</li>
        </ul>
      </li>
      <li>Bere almeno 2 litri di acqua al giorno.</li>
      <li>Limitare il consumo di sale, sia a tavola che in cucina. Usa senza limitazioni condimenti extra come spezie e
        aromi (origano, timo, succo di limone, basilico, rosmarino, ecc.).</li>
      <li>Con la giusta moderazione, goditi il tuo comfort food preferito.</li>
    </ul>

  </div>
  <div *ngIf="translate.currentLang ==='en'">
    <h3>To simplify your approach to healthy eating, here are some clarifications and explanations:</h3>
    <ul>
      <li>Remember, a healthy and effective diet should include all types of food, and “high-protein” does not
        necessarily mean “weight-loss.”</li>
      <li>Avoid smoking—both active and passive.</li>
      <li>Eat fresh vegetables and fruits daily. Increase your intake of legumes, both fresh and dried.</li>
      <li>Fats: Prefer plant-based fats, especially extra virgin olive oil, which is rich in
        polyphenols.</li>
      <li>Use raw dressings and avoid pre-cooked oils and fats.</li>
      <li>Read food labels carefully and mindfully.</li>
      <li>Limit foods that contain sucrose, especially sticky sweets that cling to your teeth.</li>
      <li>If you want to consume low-calorie sweet foods or drinks with sweeteners, read the label to check the type of
        sweetener used and the precautions to follow.</li>
      <li>Avoid ready-made sauces, fried or battered vegetables, cured meats, sausages, and salad dressings.</li>
      <li>All food weights refer to uncooked items and are net of waste (e.g., pits, shells).</li>
      <li>Lunch and dinner are fully interchangeable.</li>
      <li>Avoid pre-packaged flavor enhancers, as they tend to be high in salt.</li>
      <li>Fish: You can also consume shellfish (e.g., mussels, clams, oysters) and mollusks (e.g.,
        octopus, squid, cuttlefish).</li>
      <li>Frozen fish is also considered fresh. When consuming salmon (fresh or smoked), reduce added oil in that meal.
      </li>
      <li>When having fruit as a snack, it’s a good idea to combine it with a source of healthy fats, such as avocado,
        dark chocolate, or nuts.</li>
      <li>Once a week, try a one-dish meal based on legumes, consisting of:
        <ul>
          <li>50g of a cereal (e.g., bread, pasta, rice, barley, farro),</li>
          <li>50g of legumes (if dried, or 150g if canned),</li>
          <li>around 200g of vegetables.</li>
        </ul>
      </li>
      <li>Drink at least 2 liters of water per day.</li>
      <li>Limit salt intake both at the table and while cooking. Feel free to use extra condiments like herbs and spices
        (e.g., oregano, thyme, lemon juice, basil, rosemary, etc.).</li>
      <li>With the right moderation, enjoy your favorite comfort food.</li>
    </ul>

  </div>
</div>
